export default __webpack_public_path__ + "static/media/Padron_CorticosClosed30.9ea98acb.jpg";